import { appAxios } from "../axios/axios";
import { userTypeEnum } from "../components/FlightEnquiryForm/CreateNewAgent";
import { IResponse } from "../interfaces/requestResponse.interface";
import { IUserData } from "../interfaces/userData.interface";

export const getUsersByUuid = async (uuidArr: string[]) => {
  const apiResponse = await appAxios("/query-management/getUsersByUuid", {
    method: "POST",
    data: {
      uuids: uuidArr,
    },
  });
  const userDataResponse: IResponse<IUserData[]> = apiResponse.data;
  return userDataResponse;
};

export const getUsersBySearch = async (
  searchQuery: string,
  userType?: userTypeEnum
) => {
  const apiResponse = await appAxios(
    "/query-management-staff/getUserBySearch",
    {
      method: "POST",
      data: {
        searchQuery,
        userType,
      },
    }
  );
  const userDataResponse: IResponse<IUserData[]> = apiResponse.data;
  if (apiResponse?.data?.result?.err) {
    return {
      result: [],
      success: false,
      errorMessage: apiResponse?.data?.result?.err,
      error: apiResponse?.data?.result?.err,
    };
  }
  return userDataResponse;
};

export const getSiteStaffList = async () => {
  const data: IResponse<IUserData[]> = {
    error: null,
    errorMessage: "",
    result: [],
    success: false,
  };
  try {
    const apiResponse = await appAxios("/api/staff-user/getSiteStaffUsers", {
      method: "POST",
      data: {},
    });

    data.result = apiResponse.data.result;
    data.success = true;
  } catch (error: any) {
    const errRes: IResponse = error?.data;
    data.error = errRes.error;
    data.errorMessage = errRes.errorMessage;
  }
  return data;
};
